import { IDBEntityCacheStore } from "./IDBEntityCacheStore";
import { Timeouts } from "@gap/utils/date-utils";
import { apiClientSilent } from "api/trpc/trpc-client";
import { ProcessStatusEnum } from "@gap/backend/app-services/process/ProcessEnums";
import { ProcessDto } from "@gap/backend/app-services/process/models/ProcessDto";

export class IDBProcessCache {
   static getByStatus = async (statuses: ProcessStatusEnum[]): Promise<ProcessDto.list[]> => {
      return await IDBProcessCache.cache(statuses).fetch() || []
   }

   static invalidate = async (statusesToInvalidate: ProcessStatusEnum[]) => {
      await IDBProcessCache.cache(statusesToInvalidate).invalidate()
   }

   private static cache = (statusesToFetch: ProcessStatusEnum[]) => {
      const statuses = statusesToFetch.sort().join(',')
      return new IDBEntityCacheStore<ProcessDto.list[]>({
         entityKey: `process-list-${statuses}`,
         fetcher: () => apiClientSilent.process.list.query({ statusesToFetch }),
         cacheOptions: {
            ttlMs: Timeouts.minute * 10
         }
      })
   }
}
